// Fontawesome Imports
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faTrash, faStar, faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// General Imports
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/css/tailwind.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

library.add(faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faTrash, faStar, faPlus);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
